module.exports = __webpack_public_path__ + "img/one.5e0d2ca2.png";